import plural from 'plural-ru';

export const defaultFileLimitExceedMessage = (filesLimit: number) => {
  const noun = plural(filesLimit, 'файл', 'файла', 'файлов');

  return `Вы уже загрузили максимально возможное количество файлов. Разрешено только ${filesLimit} ${noun}`;
};
